<template>
  <rest-list
    :max-height="tableHeight"
    :payload="fetchEndpoint"
    @dataLoaded="setData($event)"
    :apply-filters-to-url="false"
  >
    <template v-if="data[0]">
      <rest-list-column
        prop="domain"
        :title="$t('CampaignChannelAnalytics_Table_Domains')"
        :width="250"
        :fixed="true"
      />
      <template v-for="(metricGroup, metricIndex) in data[0].metricGroups">
        <rest-metric-column
          v-for="(metric, index) in metricGroup.metrics"
          :prop="'metricGroups[' + metricIndex + ']'"
          :key="index"
          :index="index"
          :metric-group="metricGroup"
          :metric="metric"
        />
      </template>
    </template>
  </rest-list>
</template>

<script>
import RestList from '@/common/components/rest/RestList'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestMetricColumn from '@/common/components/rest/RestMetricColumn'
import { projectEndpoint } from '@/core/helpers'

export default {
  name: 'Domains',
  components: { RestMetricColumn, RestListColumn, RestList },
  props: {
    analyticsDateRange: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      data: []
    }
  },
  computed: {
    campaignId() {
      return this.$route.query.id || null
    },
    tableHeight() {
      return $('.page').height() - 200
    },
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `campaigns/${this.campaignId}/analytics/email/domains`,
        params: {
          date_from: this.analyticsDateRange.date_from,
          date_to: this.analyticsDateRange.date_to
        }
      })
    }
  },

  methods: {
    setData(event) {
      if (event.length) {
        this.data = event
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/analytics/Domains.vue